<template>
<w-sliding-popup type="setting" width="750px" ref="slidingPopup" title="벤더 검색" :default-content="false" @close="onClose">
  <div slot="content" class="body-content" style="height:100%;">
    <el-row class="mr-b10" type="flex" justify="end">
      <el-button size="mini" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
    </el-row>
    <el-table-wrapper style="height:calc(100% - 28px); width:100%;" :fit-height="true" ref="vendorTable" :data="vendorList" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :highlight-current-row="true"
    remote pagination :total="total" @row-click="onRowClick" @condition-change="onChangeCondition" row-class-name="c-pointer" />
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" size="large" type="solid" @click="applyVendor">적용</el-button>
    <el-button size="large" @click="onCancelButtonClick">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';

export default {
  name: 'WVendorSlidingPopup',
  data() {
    return {
      selectedRow: null,
      showSearchTool: false,
      vendorList: [],
      total: 0,
      columns: [
        {
          prop: 'objCompanyName',
          label: '벤더명',
          sortable: true,
          headerAlign: 'center',
          searchable: true,
          remoteProp: 'obj_company_name',
        },
      ],
    };
  },
  methods: {
    /**
     * 팝업 open 이벤트 핸들러
     * @author Ju
     */
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.loadData();
      });
      this.$emit('open');
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     */
    onClose() {
      this.selectedRow = null;
      this.$refs.vendorTable.clearFilter();
      this.showSearchTool = false;
      this.$emit('close');
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 벤더 정보를 로드한다.
     * @author Ju
     */
    loadData() {
      const params = this.$refs.vendorTable.getParameter();
      NetdeviceSettingAPI.getVendorInfoList(params).then((result) => {
        if (result.data.success) {
          this.vendorList = result.data.data;
          this.total = result.data.total;
        }
      });
    },
    /**
     * 테이블 조건(검색키워드, 페이지 사이즈, 페이지 index)
     * @author jda
     */
    onChangeCondition() {
      this.loadData();
    },
    /**
     * 선택한 벤더를 콤보박스에 적용한다.
     * @author Ju
     */
    applyVendor() {
      if (isEmpty(this.selectedRow)) {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '벤더'));
      } else {
        this.$emit('apply-vendor', this.selectedRow);
        this.$refs.slidingPopup.close();
      }
    },
    /**
     * 취소 버튼 클릭 이벤트 핸들러
     * @author Ju
     */
    onCancelButtonClick() {
      this.close();
    },
    /**
     * 벤더 테이블 row 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} row [description]
     */
    onRowClick(row) {
      this.selectedRow = row;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/components/popup/VendorSlidingPopup.vue